import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Chuggin\' along at church',
  date: new Date(2023, 3, 9),
  img: '/img/pigeon.jpeg',
  tracks: [
    {
      title: 'False Spring',
      src: '/songs/2023-04-09/false_spring.mp3',
    },
    {
      title: 'Overt Ops',
      src: '/songs/2023-04-09/overt_ops.mp3',
    },
    {
      title: 'Whole Milk',
      src: '/songs/2023-04-09/whole_milk.mp3',
    },
    {
      title: 'Gubmint Cheese',
      src: '/songs/2023-04-09/gubmint_cheese.mp3',
    },
    {
      title: 'Anthony took your Beer',
      src: '/songs/2023-04-09/anthony_took_your_beer.mp3',
    },
    {
      title: 'Last Chance Dance',
      src: '/songs/2023-04-09/last_chance_dance.mp3',
    },
    {
      title: 'Night Life',
      src: '/songs/2023-04-09/night_life.mp3',
    },
    {
      title: 'Pigeon',
      src: '/songs/2023-04-09/pidgeon.mp3',
    },
    {
      title: 'Hustle Bustle',
      src: '/songs/2023-04-09/hustle_bustle.mp3',
    },
    {
      title: 'Happy Easter!',
      src: '/songs/2023-04-09/happy_easter.mp3',
    },
    {
      title: 'Irish Spell',
      src: '/songs/2023-04-09/irish_spell.mp3',
    },
    {
      title: 'The Unfortunate Rise of Sarah Palin',
      src: '/songs/2023-04-09/sarah_palin.mp3',
    },
    {
      title: 'Aching Heart',
      src: '/songs/2023-04-09/aching_heart.mp3',
    },
    {
      title: 'Find Yourself There',
      src: '/songs/2023-04-09/find_yourself_there.mp3',
    },
  ]
}
export default album;